import { AxiosResponse } from "axios";
import { authClient } from "../apiClient";

export const LoginReq = async(
    data:any
): Promise<any> => {
    try {
        const response: AxiosResponse<any> = await authClient().post('/login', data)
        return response.data
    } catch (error) {
        console.error('Error login:', error);
        throw new Error('Failed to login');
    }
}

export const OAuthReq = async(
    oauthProvider: "google" | "apple",
    providerToken: string,
): Promise<any> => {
    try {
        const response: AxiosResponse<any> = await authClient().post('/oauth', {
            provider: oauthProvider,
            token: providerToken
        })
        return response.data
    } catch (error) {
        console.error('Error login with oauth:', error);
        throw new Error('Failed to login');
    }
}

export const registerReq = async(email:string, phone:string, password:string): Promise<any> => {
    try {
        const response: AxiosResponse = await authClient().post('/register', { email, password, phone, registerDevicePlatform:"web", notificationPermission:3 });
        return response.data
    } catch (error) {
        console.error('Error register:', error);
        throw new Error('Failed to login');
    }
}